import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
// PressPage.jsx
import './PressPage.css';
import { Link } from 'react-router-dom'; // add this at top

const pressCoverage = [
  {
    url: "https://www.architectandinteriorsindia.com/products/4653-trezis-virtual-reality-product-release-set-to-transform-design-communication-and-collaboration-in-the-building",
    img: "img/news/SUA_Q4j1.jpeg",
    title: "Architect & Interiors India",
    desc: "Trezi's Virtual Reality product release set to transform design communication and collaboration in the building industry"
  },
  {
    url: "https://www.livemint.com/companies/start-ups/how-the-scope-for-startups-to-experiment-with-vr-is-expanding-11571589795541.html",
    img: "img/news/Z8miKIFk.jpeg",
    title: "Livemint",
    desc: "How the scope for startups to experiment with VR is expanding"
  },
  {
    url: "https://www.thehindubusinessline.com/todays-paper/tp-others/tp-emerging-entrepreneurs/building-on-a-new-construct/article9018786.ece",
    img: "img/news/zS5VDsFc.jpeg",
    title: "The Hindu",
    desc: "Building on a new construct"
  },
  {
    url: "http://corecommunique.com/smartvizx-nominated-as-start-up-of-the-week-by-nasscom-for-start-ups/",
    img: "img/news/Uoyw_NNZ.jpeg",
    title: "Core Sector Communique",
    desc: "SmartVizX Nominated as Start‑up of the Week by NASSCOM for Start‑ups"
  },
  {
    url: "https://inc42.com/buzz/ian-yournest-invest-1-45-mn-in-virtual-reality-startup-smartvizx/",
    img: "img/news/rfm86s3D.jpeg",
    title: "Inc42",
    desc: "YourNest, IAN Invest $1.45 Mn In Virtual Reality Startup SmartVizX"
  },
  {
    url: "http://www.chicagobusiness.com/realestate/20170627/CRED0701/170629869/the-next-frontier-in-condo-sales-its-straight-out-of-star-trek",
    img: "img/news/36.jpg",
    title: "Chicago Business",
    desc: "The next frontier in condo sales? It's straight out of 'Star Trek.'"
  },
  {
    url: "http://timesofindia.indiatimes.com/tech/tech-news/For-these-startups-future-is-now/articleshow/51073819.cms",
    img: "img/news/1.jpg",
    title: "The Times of India",
    desc: "For these startups, future is now"
  },
  {
    url: "http://techstory.in/women-entrepreneurs-india/",
    img: "img/news/2.jpg",
    title: "Tech Story",
    desc: "Standup Women Entrepreneurs for Startup India"
  },
  {
    url: "http://realty.economictimes.indiatimes.com/news/industry/its-a-big-open-exciting-race-out-there-in-virtual-reality-space-gautam-tewari-founder-smartvizx/50830769",
    img: "img/news/3.jpg",
    title: "Economic Times Realty",
    desc: "It's a big, open & exciting race out there in virtual reality space: Gautam Tewari"
  },
  {
    url: "http://content.timesjobs.com/startup-india-and-job-creation-what-to-expect/?fromsite=toi",
    img: "img/news/4.jpg",
    title: "The Times of India",
    desc: "Startup India and job creation: What to expect"
  },
  {
    url: "http://www.businesstoday.in/opinion/interviews/start-up-india-intends-to-build-a-strong-eco-system-for-women-entrepreneurs/story/228461.html",
    img: "img/news/5.jpg",
    title: "Business Today",
    desc: "Start‑up India intends to build a strong eco‑system for women entrepreneurs"
  },
  {
    url: "http://www.dailypioneer.com/avenues/virtually-real-talent.html",
    img: "img/news/6.jpg",
    title: "The Pioneer",
    desc: "Virtually real talent"
  },
  {
    url: "https://economictimes.indiatimes.com/small-biz/startups/how-indian-startup-smartvizx-is-using-virtual-reality-in-real-estate-product-design/articleshow/48311803.cms",
    img: "img/news/7.jpg",
    title: "The Economic Times",
    desc: "How Indian startup SmartVizX is using virtual reality in real estate & product design"
  },
  {
    url: "https://economictimes.indiatimes.com/small-biz/startups/plethora-of-investors-as-negotiating-power-of-startups-gets-stronger-overvaluations-can-be-a-challenge/articleshow/48838872.cms",
    img: "img/news/8.jpg",
    title: "The Economic Times",
    desc: "Plethora of investors: negotiating power of startups gets stronger, overvaluations can be a challenge"
  },
  {
    url: "http://www.thenational.ae/business/economy/indian-start-ups-growing-strong-on-talent-and-funds#page2",
    img: "img/news/9.jpg",
    title: "The National Business",
    desc: "Indian start‑ups growing strong on talent and funds"
  },
  {
    url: "http://propdaily.com/select-virtual-reality-startup-smartvizx-raises-rs-3-5-crore-indian-angel-network-stanford-angels/",
    img: "img/news/10.jpg",
    title: "Propdaily",
    desc: "Smartvizx announces VR and AR solutions for businesses"
  },
  {
    url: "http://techstory.in/smartvizx/",
    img: "img/news/11.jpg",
    title: "Tech Story",
    desc: "SmartVizX – Virtual Reality Platform Using Architectural Design + Gaming + Coding To Disrupt Digital Real Estate Market!"
  },
  {
    url: "http://www.infotechlead.com/news-2/smartvizx-unveils-virtual-reality-and-augmented-reality-solutions-32211",
    img: "img/news/12.jpg",
    title: "Infotechlead",
    desc: "SmartVizX unveils virtual reality and augmented reality solutions"
  },
  {
    url: "http://knowstartup.com/2015/08/smartvizx/",
    img: "img/news/13.jpg",
    title: "Knowstartup",
    desc: "Indian startup SmartVizX uses virtual reality in real estate & product design"
  },
  {
    url: "http://www.animationxpress.com/index.php/latest-news/game-jam-titans-kicks-off-in-delhi-next-stop-hyderabad",
    img: "img/news/14.jpg",
    title: "Animationxpress",
    desc: "Game Jam Titans kicks off in Delhi; next stop Hyderabad"
  },
  {
    url: "http://realty.economictimes.indiatimes.com/realty-check/innovation-adoption-of-new-tech-trends-shot-in-the-arm-that-real-estate-needs/1522",
    img: "img/news/15.jpg",
    title: "Economic Times Realty",
    desc: "Innovation & adoption of new tech trends: shot in the arm real estate needs"
  },
  {
    url: "http://gadgets.ndtv.com/tv/features/vr-in-india-shows-caution-and-optimism-842450",
    img: "img/news/16.jpg",
    title: "NDTV Gadgets 360",
    desc: "VR in India shows caution and optimism"
  },
  {
    url: "http://www.dqindia.com/realty-vr-tech-startup-smartvizx-launches-research-development-facility-in-bengaluru/",
    img: "img/news/17.jpg",
    title: "Dataquest",
    desc: "Realty VR Tech startup SmartVizX launches R&D facility in Bengaluru"
  },
  {
    url: "http://tech.economictimes.indiatimes.com/news/startups/startups-like-smartvizx-meraki-come-up-with-vr-solutions-as-cos-embrace-new-tech/53257988",
    img: "img/news/18.jpg",
    title: "Economic Times Tech",
    desc: "Startups like SmartVizX, Meraki come up with VR solutions as companies embrace new tech"
  },
  {
    url: "http://analyticsindiamag.com/10-startups-changing-face-virtual-reality-india/",
    img: "img/news/19.jpg",
    title: "Analytics India",
    desc: "10 startups that are changing the face of Virtual Reality in India"
  },
  {
    url: "https://realty.economictimes.indiatimes.com/news/technology/Indian-VR-Startup-SmarvizX-Is-On-To-Something-Absolutely-Disruptive/52950225",
    img: "img/news/20.jpg",
    title: "The Economic Times",
    desc: "Indian VR Startup SmarvizX Is On To Something Absolutely Disruptive!"
  },
  {
    url: "http://tech.economictimes.indiatimes.com/news/startups/virtual-reality-startup-smartvizx-announces-rd-facility-in-bengaluru/52141421",
    img: "img/news/21.jpg",
    title: "Economic Times Tech",
    desc: "Virtual reality startup SmartVizX announces R&D facility in Bengaluru"
  },
  {
    url: "http://techstory.in/technology-save-environment/",
    img: "img/news/22.jpg",
    title: "Tech Story",
    desc: "How Can Technology Save Environment And Give Our Planet A Fresh Lease of Life!"
  },
  {
    url: "http://vrfocus.com/archives/25139/smartvizx-launches-vr-solutions-for-business/",
    img: "img/news/23.jpg",
    title: "VR Focus",
    desc: "SmartVizX Launches VR Solutions for Business"
  },
  {
    url: "http://techstory.in/smartvizx-vizer/",
    img: "img/news/24.jpg",
    title: "Tech Story",
    desc: "SmartVizX develops Visualization tool “Vizer” for the Furniture Industry"
  },
  {
    url: "http://firstreport.in/smartvizx-develops-pathbreaking-visualization-tool-vizer-for-the-furniture-industry/",
    img: "img/news/25.jpg",
    title: "First Report",
    desc: "SmartVizX develops pathbreaking Visualization tool “Vizer” for the Furniture Industry"
  },
  {
    url: "http://corecommunique.com/smartvizx-develops-path-breaking-visualization-tool-vizer-for-the-furniture-industry/",
    img: "img/news/26.jpg",
    title: "Core Communique",
    desc: "SmartVizX develops path‑breaking Visualization tool “Vizer” for the Furniture Industry"
  },
  {
    url: "http://www.pocketnewsalert.com/2015/09/SmartVizX-develops-path-breaking-Visualization-tool-Vizer-for-the-Furniture-Industry.html",
    img: "img/news/27.jpg",
    title: "Pocket News Alert",
    desc: "SmartVizX develops path‑breaking Visualization tool “Vizer” for the Furniture Industry"
  },
  {
    url: "https://propertynewsforyou.wordpress.com/2015/09/17/smartvizx-develops-path-breaking-visualization-tool-vizer-for-the-furniture-industry/",
    img: "img/news/28.jpg",
    title: "Property News For You",
    desc: "SmartVizX develops path‑breaking Visualization tool “Vizer” for the Furniture Industry"
  },
  {
    url: "http://mobilityindia.com/smartvizx-develops-pathbreaking-visualization-tool-vizer-for-the-furniture-industry/",
    img: "img/news/30.jpg",
    title: "Mobility",
    desc: "SmartVizX develops path‑breaking Visualization tool “Vizer” for the Furniture Industry"
  },
  {
    url: "http://www.pocketnewsalert.com/2015/09/Priyam-Bose-joins-advisory-board-of-SmartVizX.html",
    img: "img/news/31.jpg",
    title: "Pocket News Alert",
    desc: "Priyam Bose joins advisory board of SmartVizX"
  },
  {
    url: "http://firstreport.in/priyam-bose-joins-advisory-board-of-smartvizx/",
    img: "img/news/32.jpg",
    title: "First Report",
    desc: "Priyam Bose joins advisory board of SmartVizX"
  },
  {
    url: "http://firstreport.in/smartvizx-nominated-as-start-up-of-the-week-by-nasscom-for-start-ups/",
    img: "img/news/34.jpg",
    title: "First Report",
    desc: "SmartVizX Nominated as Start‑up of the Week by NASSCOM for Start‑ups"
  },
  {
    url: "https://www.itvarnews.com/2015/08/18/smartvizx-nominated-as-start-up-of-the-week-by-nasscom-for-start-ups/",
    img: "img/news/35.jpg",
    title: "itVARnews",
    desc: "SmartVizX Nominated as Start‑up of the Week by NASSCOM for Start‑ups"
  }
];


// src/data/pressReleases.js
export const pressReleases = [
  {
    url: "press-release/1",
    title: "SmartVizX, India’s leading Virtual Reality solutions company has announced the launch of a dedicated Research & Development facility in Bengaluru.",
    subtitle: "Realty VR Tech Startup SmartVizX Launches Research & Development Facility in Bengaluru, Makes Senior Hires To Kick Start Product Development"
  },
  {
    url: "press-release/2",
    title: "Virtual Reality (VR) Tech Company SmartVizX has created a first of its kind VR based project visualization for Developer Group’s (India’s first Japanese funded and promoted real estate company) latest Westwind Project in Chennai.",
    subtitle: "SmartVizX Introduces Path Breaking Virtual Reality Led Visualisation Services For Chennai Based Westwind Project"
  },
  {
    url: "press-release/3",
    title: "Leading Indian Virtual Reality Solutions Company SmartVizX has been recognized as a winner of the prestigious 2016 Red Herring Asia Top 100 awards.",
    subtitle: "SmartVizX Gets Selected As 2016 Red Herring Top 100 Asia Winner"
  },
  {
    url: "press-release/4",
    title: "Leading Virtual Reality Solutions Company SmartVizX announced that Vinay Narayan, ED, Virtual Reality Product Management and Head of PMO at HTC Vive has joined their Board.",
    subtitle: "Vinay Narayan of HTC Vive Joins Board of Virtual Reality Solutions Company SmartVizX"
  }
];


const PressPage = () => {
  const [activeTab, setActiveTab] = useState('coverage');

  return (
    <>
      <Navbar />

      {/* Hero Section with Video Background */}
      <div className="press-hero-section">
        <div className="background-video-wrapper">
          <video autoPlay loop muted playsInline className="background-video">
            <source src="/backvid.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="hero-content">
          <h2 className="portfolio-header">Catch the Latest Buzz</h2>
          <div className="project-desc">
            At SmartVizX, Virtual Reality is a part and parcel of our daily lives. We are
            always creating, innovating and visualizing things. Come check us out!
          </div>
        </div>
      </div>

      {/* Content Section Below Video */}
      <div className="pd-container">
        {/* Tabs */}
        <ul className="pd-tabs">
          <li
            className={activeTab === "coverage" ? "active" : ""}
            onClick={() => setActiveTab("coverage")}
          >
            Press Coverage
          </li>
        </ul>

        {/* Press Coverage */}
        <div className={`pd-photos ${activeTab === "coverage" ? "active" : ""}`}>
          <div className="product-grid services-grid">
            {pressCoverage.map((item, index) => (
              <div className="product-card" key={index}>
                <a href={item.url} target="_blank" rel="noreferrer">
                  <div
                    className="cover-img"
                    style={{
                      backgroundImage: `url(${item.img})`,
                      height: "180px",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                  <div className="card-text">
  <h4 className="text-center">{item.title}</h4>
  <p>{item.desc}</p>
</div>

                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Press Releases */}
        <div className={`pd-photos ${activeTab === "release" ? "active" : ""}`}>
          <div className="product-grid services-grid">
            {pressReleases.map((item, index) => (
              <div className="product-card" key={index}>
                <Link to={item.url}>
                  <div
                    className="cover-img"
                    style={{
                      backgroundColor: "#f2f2f2",
                      height: "180px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "0 10px",
                    }}
                  >
                    <span style={{ color: "#555" }}>Press Release</span>
                  </div>
                  <h4 className="text-center">{item.subtitle}</h4>
                  <p>{item.title}</p>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PressPage;